// @flow
import React from 'react'
import { connect } from 'react-redux'
import { AppBar, Grid, Toolbar, withWidth } from '@material-ui/core'
import { includes } from 'lodash/collection'
import { isEmpty } from 'lodash/lang'
import i18n from 'i18next'

import { accountActions } from '@modules/account'
import { routerActions } from '@modules/router'
import { availableLanguages } from '../../i18n'
import { DAMM_RED } from '../../theme/colors.js'
import Cart from './Cart'
import AuthStatusToggle from './AuthStatusToggle'
import Logo from './Logo'
import Drawer from './Drawer'
import LanguageSelector from './LanguageSelector'
import FreeDeliveryMessage from './FreeDeliveryMessage'
import styles from './styles'

type Props = {
  availableLanguages: Array<Object>,
  background: string,
  cartTotal: number,
  catalogID: string,
  changeLanguage: Function,
  color: string,
  drawer: boolean,
  freeDeliveryMessage: boolean,
  hasNoPadding: boolean,
  isAtCheckout: boolean,
  isAtHomePage: boolean,
  isAuthenticated: boolean,
  isCartEmpty: boolean,
  isDrawerPermanentlyOpen: boolean,
  multiLanguagesPaths: Object,
  language: string,
  position: string,
  productID?: any,
  navigateTo: Function,
  staticPageID?: string,
  width: string
}

export const mapDispatchToProps = (dispatch: Function) => ({
  changeLanguage: (language: string, isAuthenticated: boolean) => {
    return dispatch(accountActions.changeLanguage(language, isAuthenticated))
  },
  navigateTo: (to: string) => dispatch(routerActions.navigateTo(to))
})

const mapStateToProps = (state: Object, own: Object) => ({
  availableLanguages: availableLanguages,
  cartTotal: state.cart.total,
  isAtCheckout: includes(state.router.location.pathname, 'checkout'),
  isAtHomePage: false,
  isAuthenticated: !!state.auth.customerToken,
  isCartEmpty: isEmpty(state.cart.itemList)
})

export class Navbar extends React.Component<Props> {
  static defaultProps = {
    color: DAMM_RED
  }

  render () {
    const color = this.props.isAtHomePage ? this.props.color : '#000000'
    return this.props.width === 'xs' || this.props.width === 'sm' ? (
      <AppBar
        position={this.props.isAtHomePage ? 'fixed' : 'static'}
        style={styles.navbarMobile(
          this.props.freeDeliveryMessage,
          this.props.hasNoPadding,
          this.props.background
        )}
      >
        <Toolbar variant='dense' style={styles.toolbarMobile(color)}>
          <Drawer
            availableLanguages={this.props.availableLanguages}
            catalogID={this.props.catalogID}
            changeLanguage={this.props.changeLanguage}
            color={color}
            isAtMobileView
            isAuthenticated={this.props.isAuthenticated}
            language={i18n.language}
            productID={this.props.productID}
            staticPageID={this.props.staticPageID}
            multiLanguagesPaths={this.props.multiLanguagesPaths}
            navigateTo={this.props.navigateTo}
          />
          <Logo
            color={this.props.isAtHomePage ? color : DAMM_RED}
            height={25}
            width={66}
          />
          <AuthStatusToggle
            color={color}
            isAuthenticated={this.props.isAuthenticated}
            width={this.props.width}
          />
          {!this.props.isAtCheckout && (
            <Cart
              color={color}
              navigateTo={this.props.navigateTo}
              total={this.props.cartTotal}
              isCartEmpty={this.props.isCartEmpty}
              width={this.props.width}
            />
          )}
        </Toolbar>
        {this.props.freeDeliveryMessage && (
          <FreeDeliveryMessage isAtMobile={this.props.width === 'xs'} />
        )}
      </AppBar>
    ) : (
      <AppBar
        position={this.props.position || 'static'}
        style={styles.navbarDesktop(
          this.props.freeDeliveryMessage,
          this.props.background
        )}
      >
        <Toolbar style={styles.toolbar(color)} variant='dense' disableGutters>
          <Grid
            container
            style={styles.container(this.props.width, this.props.isAtHomePage)}
          >
            {this.props.drawer && (
              <Drawer
                background={this.props.background}
                catalogID={this.props.catalogID}
                isAtHomePage={this.props.isAtHomePage}
                color={color}
                freeDeliveryMessage={this.props.freeDeliveryMessage}
                width={this.props.width}
                isPermanentlyOpen={this.props.isDrawerPermanentlyOpen}
                productID={this.props.productID}
                staticPageID={this.props.staticPageID}
              />
            )}
            <Logo
              color={this.props.isAtHomePage ? color : DAMM_RED}
              height={38}
              width={96}
            />
            <AuthStatusToggle
              color={color}
              isAuthenticated={this.props.isAuthenticated}
              width={this.props.width}
            />
            {!this.props.isAtCheckout && (
              <Cart
                color={color}
                navigateTo={this.props.navigateTo}
                total={this.props.cartTotal}
                isCartEmpty={this.props.isCartEmpty}
                width={this.props.width}
              />
            )}
            <LanguageSelector
              color={color}
              language={i18n.language}
              multiLanguagesPaths={this.props.multiLanguagesPaths}
              availableLanguages={this.props.availableLanguages}
              changeLanguage={this.props.changeLanguage}
              isAuthenticated={this.props.isAuthenticated}
              navigateTo={this.props.navigateTo}
            />
          </Grid>
        </Toolbar>
        {this.props.freeDeliveryMessage && <FreeDeliveryMessage />}
      </AppBar>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(Navbar))
